import CrudCustom from '../../../libs/custom/CrudCustom';

let BatasUpahHarianService = new CrudCustom('/batas-upah-harians');
export default BatasUpahHarianService;
